import css from 'styled-jsx/css';

const styles = css.global`#bens-servicos-busca-loja {
  position: relative;
}

#bens-servicos-busca-loja.busca-ativada {
  height: 913px;
}

#bens-servicos-busca-loja .ctn-home-24 {
  height: 320px;
  position: relative;
  z-index: 10;
}

#bens-servicos-busca-loja .ver-todas-btn {
  border: none;
  background: none;
  font-family: 'SantanderText';
  font-size: 16px;
  color: rgb(204, 0, 0) !important;
  margin-top: 20px;
  cursor: pointer;
}

.resultados p {
  font-family: "SantanderText";
}

.resultados h2 {
  font-family: "SantanderHeadline";
}

.contentSelect {
  position: relative;
  width: 250px;
  padding: 16px 0;
  margin-top: 16px;
}

.contente-dropdown {
  margin: 15px 0;
}

.contente-dropdown * {
  font-family: "SantanderText";
}

.dropdown-title {
  color: #C00 !important;
}

.container {
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 40px 0;
  gap: 24px;
  overflow: hidden;
  touch-action: none;
}

.busca-titulos {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.busca-titulos .busca-titulo {
  color: #FFF;
  font-family: "SantanderHeadline";
  font-size: 24px;
  font-style: normal;
  font-weight: 400;
  line-height: 36px;
}

.busca-titulos .busca-subtitulo {
  color: #FFF;
  font-family: "SantanderText";
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px;
}

.buscaContainer {
  display: flex;
  align-items: center;
  width: 100%;
  position: relative;
  z-index: 10;
  gap: 24px;
  flex-direction: column;
}

.campoBuscaWrapper {
  position: relative;
  width: 100%;
  max-width: 780px;
  overflow: hidden;
}

.campoBusca {
  width: 100%;
  padding: 10px 36px 10px 40px;
  font-size: 16px;
  border: 1px solid #ccc;
  max-width: 780px;
  height: 48px;
}

.campoBusca:focus {
  border: 1px solid #5AB8CA;
  outline: none;
  border-radius: 5px;
}

.iconeLupa {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 18px;
  color: #999;
}

.botaoFecharInput {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 16px;
  border: none;
  background: none;
  cursor: pointer;
  color: #aaa;
  padding: 0;
}

.botaoFecharInput:hover {
  color: #444;
}


.placeholderFalso {
  position: absolute;
  left: 40px;
  top: 50%;
  transform: translateY(-50%);
  color: #888;
  font-size: 15px;
  pointer-events: none;
  white-space: nowrap;
  font-family: "SantanderHeadline";
}

.dropdown {
  margin: 10px 0 10px;
}

.placeholderFalso button {
  all: unset;
  pointer-events: auto;
  color: #888;
  cursor: pointer;
  text-decoration: underline;
}

.placeholderFalso button:hover {
  color: #C00;
}

.pac-matched {
  color: #444;
}

.botaoBusca {
  width: 100%;
  max-width: 334px;
  height: 48px;
  border: 1px solid #CC0000;
  border-radius: 4px;
  color: #CC0000;
  font-size: 18px;
  cursor: pointer;
}

.mapaContainer {
  position: absolute;
  width: 100%;
  overflow: hidden;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
}

.mapa {
  width: 100%;
  height: 232px;
}

.fade {
  position: absolute;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.6);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  z-index: 5;
  max-height: 320px;
}

.resultados {
  background-color: white;
  border-top: 1px solid #ccc;
  padding: 16px;
  max-height: 682px;
  position: absolute;
  border-radius: 16px;
  bottom: 0;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
  width: 300px;
  left: 0;
}

.icone-modal {
  rotate: 270deg;
}

.content-results {
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  touch-action: pan-y;
  height: 150px;
  margin-top: 0px;
  padding: 0 !important;
}

.content-btn {
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.resultados h2 {
  font-weight: 500;
  color: #000;
  text-align: start !important;
  border-radius: 8px 8px 0px 0px;
}

.resultados h2::after {
  margin-top: 24px;
  background: #CCC;
  content: "";
  display: block;
  width: 100%;
  height: 1px;
}

.categoriaSelect {
  width: 260px !important;
  height: 46px;
  padding: 0 12px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-family: 'SantanderText';
  font-size: 18px;

  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
}

.lojaItem {
  padding: 16px;
  position: relative;
  cursor: default;
}

.lojaItem::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 6%;
  width: 90%;
  height: 1px;
  background-color: #eee;
}

.lojaItem p {
  font-family: 'SantanderText';
}

.lojaItem h3 {
  font-weight: bold;
  margin-bottom: 4px;
  color: #000;
  margin: 0px;
  font-size: 18px;
  font-family: 'SantanderText';
  font-weight: 600;
}

.resultados::-webkit-scrollbar {
  width: 8px;
}

.resultados::-webkit-scrollbar-thumb {
  background: #ccc;
  border-radius: 4px;
}

.lojaItem hr {
  margin-top: 32px !important;
}

.resultados {
  overflow: hidden;
}

.drag-handle {
  cursor: grab;
}

.drag-handle:active {
  cursor: grabbing;
}

.fade {
  pointer-events: none;
}

.dropdown {
  border: none !important;
  padding: 0 !important;
  justify-content: flex-start !important;
}

.dropdown .dropdown-arrow {
  margin-left: 15px;
  width: 15px;
  height: 15px;
  top: 2px;
  position: relative;
}


@media (min-width: 992px) {
  #bens-servicos-busca-loja .ctn-home-24 {
    height: 232px;
  }

  .resultados {
    left: unset;
  }

  .buscaContainer {
    flex-direction: row;
  }

  .dropdown {
    margin: 10px 0 !important;
  }
  .content-results {
    height: 480px
  }
}

.container {
  gap: 32px;
}

.content-results {
  margin-top: 45px;
}

.contente-dropdown {
  margin: 25px 0 10px;
}

.botaoBusca {
  max-width: 272px;
  background-color: #fff;
}

.resultados {
  padding: 0 !important;
}

.resultados p {
  padding: 24px;
}

.lojaItem p {
  padding: 5px 0 5px 0 !important;
}

.categoriaSelect {
  width: 280px !important;
  height: 60px;
}

.content-title {
  display: flex;
  background: #FFF;
  box-shadow: 0px 4px 8px -2px rgba(34, 34, 34, 0.4);
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px 16px;
  height: 65px;
  flex-direction: column;
}

.content-title button {
  position: unset;
  transform: unset;
}

.contentSelect {
  position: relative;
  width: 290px;
  padding: 16px;
  margin-top: 16px;
}

.resultados h2::after {
  display: none;
}
`;

export default styles;